import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class AddressValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && !this.isDisabled && !this.isHidden) {
            this.addToOptionInjection({
                key: "Required",
                value: "true",
                type: "Boolean"
            })

            this.attribute.attributes.forEach(childAttribute => {
                let validator = ValidationStrategyFactory.create(childAttribute, this.injectedOptions);

                let integrationFieldOpt = childAttribute.options
                    .find(opt => opt.key.toLowerCase() == "integrationfield")

                if(integrationFieldOpt && integrationFieldOpt.value.toLowerCase() == "complement") {
                    validator = ValidationStrategyFactory.create(childAttribute);
                }

                let isValidChild = validator.validate();
                isValid = isValidChild && isValid;
            });
        }

        return isValid
    }
}